import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Paper, Box, Divider } from '@material-ui/core'

import { normalizeData } from './normalizer'
import Header from './Header'
import Graph from './Graph'
import Footer from './Footer'
import TableView from './TableView'
import ErrorMessage from '../ErrorMessage'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Measure from 'react-measure'
import { debounce } from 'lodash'

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.pageBackground?.light || 'white',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 499,
    height: '100%',
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  graphContainer: {
    height: 387,
  },
}))

const InterestedStudentsByMonthCard = ({ data, loading, error }) => {
  const [selectedClassYear, setSelectedClassYear] = useState('all')
  const [tableView, setTableView] = useState(false)
  const [height, setHeight] = useState(undefined)
  const classes = useStyles()
  const theme = useTheme()
  const normalizedData = useMemo(() => normalizeData(data), [data])
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))
  const debounceResize = useMemo(
    () =>
      debounce((newWidth, newHeight) => {
        if (isSmall) {
          setTableView(true)
          setHeight(newHeight - 94 - 54)
        }
      }),
    [isSmall, setHeight, setTableView],
  )

  return (
    <Measure
      onResize={(contentRect) => {
        if (contentRect && contentRect.entry) {
          debounceResize(contentRect.entry.width, contentRect.entry.height)
        }
      }}
    >
      {({ measureRef }) => (
        <Paper
          ref={measureRef}
          className={classes.paper}
          elevation={0}
        >
          <Header
            loading={loading}
            error={error}
            selectedClassYear={selectedClassYear}
            classYears={data && data.map((classYear) => classYear.grad_year)}
            onChange={(year) => setSelectedClassYear(year)}
            tableView={tableView}
            onViewToggle={(tableView) => setTableView(tableView)}
            disableToggle={isSmall}
          />
          <Divider light />
          <Box className={classes.cardContent}>
            {error ? (
              <Box
                className={classes.graphContainer}
                height={height}
              >
                <ErrorMessage title="Sorry, we don’t currently have any data for this selection." />
              </Box>
            ) : tableView ? (
              <TableView
                data={normalizedData[selectedClassYear]}
                rowsPerPage={6}
              />
            ) : (
              <React.Fragment>
                <Box
                  className={classes.graphContainer}
                  height={height}
                >
                  <Graph
                    loading={loading}
                    data={normalizedData[selectedClassYear]}
                  />
                </Box>
                <Footer />
              </React.Fragment>
            )}
          </Box>
        </Paper>
      )}
    </Measure>
  )
}

InterestedStudentsByMonthCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default InterestedStudentsByMonthCard
